import { cn } from '@/lib/cn';

// Paid (default) vs Pending toggle for Shopify financial_status. Prize and
// sample orders are $0, so Paid is almost always right.
export function PaymentStatusToggle({
  value,
  onChange,
}: {
  value: 'paid' | 'pending';
  onChange: (v: 'paid' | 'pending') => void;
}) {
  const btn = (key: 'paid' | 'pending', label: string, activeClasses: string) => (
    <button
      type="button"
      onClick={() => onChange(key)}
      className={cn(
        'flex-1 rounded-sm border px-3 py-1.5 text-[11.5px] font-semibold transition-colors',
        value === key ? activeClasses : 'border-border bg-transparent text-muted hover:bg-bg'
      )}
    >
      {label}
    </button>
  );
  return (
    <div>
      <div className="flex gap-2">
        {btn('pending', 'Pending', 'border-primary bg-primary/10 text-primary')}
        {btn('paid', 'Paid', 'border-success bg-success/10 text-success')}
      </div>
      <p className="mt-1.5 rounded-sm bg-bg px-2 py-1 text-[10.5px] text-subtle">
        Defaults to <strong>Paid</strong>. Switch to Pending only if payment collection is needed.
      </p>
    </div>
  );
}
